import {mapsApi, objectsApi} from "../../API/API";
import {SET_ADDRESSES, SET_CITIES, SET_COUNTRIES, SET_OBJECT_TYPES} from "./constans";

export const setObjectTypes = (payload) => {
    return {
        type: SET_OBJECT_TYPES,
        payload
    }
};

export const setCountries = (payload) => {
    return {
        type: SET_COUNTRIES,
        payload
    }
};

export const setCities = (payload) => {
    return {
        type: SET_CITIES,
        payload
    }
};

export const setAddresses = (payload) => {
    return {
        type: SET_ADDRESSES,
        payload
    }
};




export const getTypes = () => async (dispatch) => {
    let response = await objectsApi.getTypes()

    if (response.status) {
        dispatch(setObjectTypes(response.data))
    }
}

export const getCountries = () => async (dispatch) => {
    let response = await mapsApi.getCountries()

    if (response.status) {
        dispatch(setCountries(response.data))
    }
}

export const getCities = (country) => async (dispatch) => {
    let response = await mapsApi.getCities({country})

    if (response.status) {
        dispatch(setCities(response.data))
    }
}

export const geoCode = (location) => async (dispatch) => {


    let response = await mapsApi.geoCode({location})


    if (response.status) {
        let addresses = []

        let firstGeoPosition = ''
        response.data.GeoObjectCollection.featureMember.map((item, index) => {

            let position = item.GeoObject.Point.pos
            let address = item.GeoObject.metaDataProperty.GeocoderMetaData.text


            if (index === 0) {
                firstGeoPosition = position
            }
            addresses.push({position, address})
        })

        let newLocation = ''

        if (location.split(", ").length > 3) {
            newLocation = new Set(location.split(", "))
            newLocation = [...newLocation].join(", ")
        }

        if (!addresses.find(item => item.address === newLocation)) {
            addresses.push({position: firstGeoPosition, address: newLocation ? newLocation : location})
        }

        dispatch(setAddresses(addresses))
    }
}

